<template>
  <div class="user-list-container">
    <!-- 筛选条件区域 -->
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="4" :colGap="26" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item label="用户名" label-col-flex="60px">
              <a-input v-model="queryForm.username" placeholder="请输入用户名" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="昵称" label-col-flex="60px">
              <a-input v-model="queryForm.nickname" placeholder="请输入昵称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="状态" label-col-flex="60px">
              <a-select v-model="queryForm.status" placeholder="请选择状态">
                <a-option value="">全部</a-option>
                <a-option value="0">启用</a-option>
                <a-option value="1">禁用</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <a-space>
              <a-button type="primary" @click="handleQuery" :loading="loading">
                <template #icon>
                  <icon-search style="stroke: #fff"/>
                </template>
                搜索
              </a-button>
              <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
              <a-button type="text" @click="()=>{collapsed = !collapsed}">
                <template #icon>
                  <icon-down v-if="collapsed"/>
                  <icon-up v-else/>
                </template>
                {{ collapsed ? '展开' : '收起' }}
              </a-button>
            </a-space>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="手机号" label-col-flex="60px">
              <a-input v-model="queryForm.phone" placeholder="请输入手机号" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
        </a-grid>
      </a-form>
    </canvas-glass-card>

    <a-space/>

    <!-- 用户列表表格 -->
    <canvas-glass-card variant="primary" :hoverable="false" class="table-card">
      <template #header>
        <a-row>
          <a-col flex="200px">
            <span class="glass-card__title">客户账户列表</span>
          </a-col>
          <a-col flex="auto"/>
          <a-col flex="350px">
            <a-row flex="150px" justify="space-between" :wrap="false">
              <a-button type="primary" @click="importAccount()">
                <template #icon>
                  <icon-to-bottom style="stroke: #fff;" />
                </template>
                导入
              </a-button>
              <a-button type="primary" @click="exportAccount()">
                <template #icon>
                  <icon-to-top style="stroke: #fff"/>
                </template>
                导出
              </a-button>
              <a-button type="primary" @click="addAccount()">
                <template #icon>
                  <icon-plus style="stroke: #fff"/>
                </template>
                新增
              </a-button>
              <a-tooltip content="列设置">
                <a-button type="text" @click="showColumnSetting = true">
                  <template #icon>
                    <icon-settings/>
                  </template>
                </a-button>
              </a-tooltip>
              <a-tooltip content="刷新">
                <a-button type="text" @click="fetchTableData">
                  <template #icon>
                    <icon-refresh/>
                  </template>
                </a-button>
              </a-tooltip>
            </a-row>
          </a-col>
        </a-row>
      </template>

      <!-- 用户列表表格 -->
      <a-table
          row-key="id"
          v-bind:columns="visibleColumns"
          :data="pagination.records"
          :pagination="false"
          :loading="loading"
          column-resizable
          stripe
          :bordered="{cell:true}"
          :scroll="{ x: 1000 }"
          :row-selection="{
            type: 'checkbox',
            showCheckedAll: true
          }"
          v-model:selectedKeys="selectedRowKeys"
      >

<!--        <template #type="{ record }">-->
<!--          {{ getTypeText(record.type) }}-->
<!--        </template>-->

        <template #status="{ record }">
          <a-tag :color="getStatusColor(record.status)">
            {{ getStatusText(record.status) }}
          </a-tag>
        </template>

        <!--        <template #outsource="{ record }">-->
<!--          {{ getOutsourceText(record.outsource) }}-->
<!--        </template>-->

<!--        <template #locked="{ record }">-->
<!--          {{ getLockedText(record.locked) }}-->
<!--        </template>-->

        <template #createTime="{ record }">
          {{ formatDate(record.createTime) }}
        </template>

        <template #action="{ record }">
          <a-space>
            <!-- 选项 -->
            <a-button type="text" size="mini" status="normal" @click="showInfoBefore(record)"
                      class="button-table-option">
              <template #icon>
                <icon-list />
              </template>
              详情
            </a-button>
<!--            <a-button type="text" size="mini" status="success" @click="editAccount(record)"-->
<!--                      class="button-table-option">-->
<!--              <template #icon>-->
<!--                <icon-edit />-->
<!--              </template>-->
<!--              编辑-->
<!--            </a-button>-->
            <a-button type="text" size="mini" status="warning" @click="deleteAccountBefore(record)"
                      class="button-table-option">
              <template #icon>
                <icon-delete />
              </template>
              删除
            </a-button>
          </a-space>
        </template>
      </a-table>
      <!-- 分页组件 -->
      <a-pagination
          style="justify-content: end;margin: 10px;"
          v-model:current="pagination.current"
          v-model:page-size="pagination.size"
          :total="pagination.total"
          :page-size-options="[10, 20, 50, 100]"
          show-total
          show-jumper
          show-page-size
          @change="handlePageChange"
          @page-size-change="handlePageSizeChange"
      />
    </canvas-glass-card>

    <!-- 列设置模态框 -->
    <a-drawer
        :visible="showColumnSetting"
        title="列设置"
        @ok="handleColumnSettingOk"
        @cancel="showColumnSetting = false"
        width="300px"
        :mask-closable="false"
        :hide-cancel="true"
    >
      <div class="column-setting">
        <a-checkbox-group v-model="selectedColumns" direction="vertical">
          <a-checkbox
              v-for="column in allColumns"
              :key="column.dataIndex"
              :value="column.dataIndex"
              :disabled="column.required"
          >
            {{ column.title }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </a-drawer>

    <!-- 详情抽屉 -->
    <detail-drawer 
        v-model="isShowDetailDrawer" 
        :account-id="accountInfoCopy.id"
    />
    
    <!-- 新增/修改客户账号模态框 -->
    <edit-modal 
        v-model="isShowEditModal" 
        :account-id="currentEditAccountId"
        @success="handleEditSuccess"
    />
    
    <!-- 导入客户账号模态框 -->
    <import-modal 
        v-model="isShowImportModal" 
        @success="handleImportSuccess"
    />
    
    <!-- 用户删除模态框 -->
    <a-modal
        v-model:visible="isShowDeleteAccountModal"
        :on-before-ok="delAccount"
        ok-text="删除"
        @cancel="isShowDeleteAccountModal = false"
        draggable
    >
      <template #title>
        是否删除
      </template>
      <div>确定要删除[<strong>{{ accountInfoCopy.username }}</strong>]吗？</div>
    </a-modal>
  </div>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import { getCustomerAccountPage, deleteCustomerAccount, exportCustomerAccount } from '@/apis/customer-data'
import CanvasGlassCard from '@/components/CanvasGlassCard.vue'
import DetailDrawer from '@/components/Customers/Account/DetailDrawer.vue'
import EditModal from '@/components/Customers/Account/_Edit.vue'
import ImportModal from '@/components/Customers/Account/ImportModal.vue'
import {
  IconSearch,
  IconDown,
  IconUp,
  IconPlus,
  IconSettings,
  IconRefresh,
  IconDelete,
  IconToBottom,
  IconToTop
} from '@arco-design/web-vue/es/icon'
import {Message} from "@arco-design/web-vue";
import {timestampNumber2dateString} from "@/utils/date-util";

// 条件查询表单折叠
const collapsed = ref(true)

// 是否显示详情抽屉
const isShowDetailDrawer = ref(false)
// 是否显示新增/修改客户账号模态框
const isShowEditModal = ref(false)
// 是否显示导入客户账号模态框
const isShowImportModal = ref(false)
// 是否显示删除客户账号模态框
const isShowDeleteAccountModal = ref(false)
// 客户账号信息
const accountInfoCopy = ref({})
// 当前编辑的账号ID
const currentEditAccountId = ref(null)
// 表格多选相关
const selectedRowKeys = ref([])

// 筛选条件
const queryForm = ref({
  username: '',
  nickname: '',
  phone: '',
  status: '',
  // createTimeRange: []
})

// 客户账号列表数据
let pagination = ref({
  records: [],
  current: 1,
  size: 10,
  pages: 0,
  total: 0
})
// 加载状态
const loading = ref(false)

// 列设置相关
const showColumnSetting = ref(false)
const selectedColumns = ref([
  'code',
  'username',
  'nickname',
  'phone',
  'email',
  // 'type',
  'status',
  // 'outsource',
  // 'locked',
  'createTime',
  'action'
])

// 所有列定义
const allColumns = ref([
  // { title: 'ID', dataIndex: 'id', width: 80, required: true, },
  {title: '账号编码', dataIndex: 'code', width: 120, required: true, fixed: 'left',},
  {title: '用户名', dataIndex: 'username', width: 120, required: true, fixed: 'left', ellipsis: true, tooltip: true,},
  {title: '昵称', dataIndex: 'nickname', width: 120, ellipsis: true, tooltip: true,},
  {title: '手机号', dataIndex: 'phone', width: 130, ellipsis: true, tooltip: true,},
  {title: '邮箱', dataIndex: 'email', width: 180, ellipsis: true, tooltip: true,},
  // {title: '用户类型', dataIndex: 'type', width: 100, slotName: 'type',},
  {title: '状态', dataIndex: 'status', width: 80, slotName: 'status',},
  // {title: '是否外包', dataIndex: 'outsource', width: 100, slotName: 'outsource',},
  // {title: '账号锁', dataIndex: 'locked', width: 100, slotName: 'locked',},
  {title: '创建时间', dataIndex: 'createTime', width: 180, slotName: 'createTime',},
  {title: '操作', dataIndex: 'action', width: 100, slotName: 'action', align: 'center', fixed: 'right', required: true,}
])

// 可见列计算属性
const visibleColumns = computed(() => {
  return allColumns.value.filter(column => selectedColumns.value.includes(column.dataIndex))
})

// 获取客户账号列表
const fetchTableData = async () => {
  loading.value = true

  getCustomerAccountPage({
    ...queryForm.value,
    current: pagination.value.current,
    size: pagination.value.size
  }).then(response => {
    // console.log(response)
    loading.value = false;
    if (response.code === 0) {
      pagination.value = response.data;
      // console.log(pagination.value)
    } else {
      Message.error(response.message);
      console.error('获取客户账号列表失败:', response)
    }
  }).catch(error => {
    Message.error(error.message || '获取客户账号列表失败');
    console.error('获取客户账号列表失败:', error)
  })
}

// 搜索客户账号
const handleQuery = () => {
  pagination.current = 1
  fetchTableData()
}

// 重置筛选条件
const handleReset = () => {
  Object.keys(queryForm.value).forEach(key => {
    queryForm.value[key] instanceof Array ? queryForm.value[key].length = 0 : queryForm.value[key] = ''
  })
  fetchTableData()
}

// 处理页码变化
const handlePageChange = (page) => {
  fetchTableData()
}

// 处理每页数量变化
const handlePageSizeChange = (size) => {
  pagination.current = 1
  fetchTableData()
}

// 列设置相关方法
const handleColumnSettingOk = () => {
  showColumnSetting.value = false
  // 这里可以保存用户的列设置到本地存储
  localStorage.setItem('customerAccountListColumns', JSON.stringify(selectedColumns.value))
  Message.success('列设置保存成功')
}

// 格式化方法
// const getTypeText = (type) => {
//   const map = {'0': '管理员', '1': '员工'}
//   return map[type] || '未知'
// }


const getStatusColor = (status) => {
  const map = {'0': 'green', '1': 'red', }
  return map[status] || '未知'
}
const getStatusText = (status) => {
  const map = {'0': '正常', '1': '禁用', }
  return map[status] || '未知'
}

// const getOutsourceText = (outsource) => {
//   return outsource ? '是' : '否';
// }

// const getLockedText = (locked) => {
//   return locked ? '是' : '否';
// }


const formatDate = (dateString) => {
  // if (!dateString) return '-'
  // const date = new Date(dateString)
  // return date.toLocaleString('zh-CN')
  if (!dateString) return '—';
  // return dateString.substring(0, 16).replace('T', ' ');
  return timestampNumber2dateString(dateString)
}

// 客户详情
const showInfoBefore = (user) => {
  accountInfoCopy.value = user
  isShowDetailDrawer.value = true
}


// 组件挂载时获取数据
onMounted(() => {
  // 从本地存储加载列设置
  const savedColumns = localStorage.getItem('customerAccountListColumns')
  if (savedColumns) {
    try {
      selectedColumns.value = JSON.parse(savedColumns)
    } catch (e) {
      console.warn('Failed to parse saved columns:', e)
    }
  }

  fetchTableData()
})


/**
 * 操作方法
 */
// 新增客户账号
const addAccount = () => {
  currentEditAccountId.value = null
  isShowEditModal.value = true
}

// 编辑客户账号
const editAccount = (account) => {
  currentEditAccountId.value = account.id
  isShowEditModal.value = true
}

// 导入客户账号
const importAccount = () => {
  isShowImportModal.value = true
}

// 导出客户账号
const exportAccount = async () => {
  try {
    // 条件查询
    const param = {...queryForm.value}
    if (selectedRowKeys.value.length > 0) {
      param.ids = selectedRowKeys.value
    }
    
    const response = await exportCustomerAccount(param)
    
    // 创建下载链接
    const blob = new Blob([response], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `客户账户数据_${new Date().toJSON().slice(0,23).replaceAll(":","")}.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    
    Message.success('客户账户数据导出成功')
    
    // 导出后清空选中项
    selectedRowKeys.value = []
  } catch (error) {
    Message.error('导出客户账户数据失败')
    console.error('导出失败:', error)
  }
}

// 删除客户账号
const deleteAccountBefore = (account) => {
  accountInfoCopy.value = account
  isShowDeleteAccountModal.value = true
}

const delAccount = async () => {
  try {
    const response = await deleteCustomerAccount(accountInfoCopy.value.id)
    if (response.code === 0) {
      Message.success('删除客户账号成功')
      fetchTableData()
      return true
    } else {
      Message.error(response.message || '删除客户账号失败')
      return false
    }
  } catch (error) {
    Message.error('删除客户账号失败')
    console.error('删除失败:', error)
    return false
  }
}

// 编辑成功回调
const handleEditSuccess = () => {
  fetchTableData()
  selectedRowKeys.value = []
}

// 导入成功回调
const handleImportSuccess = () => {
  fetchTableData()
  selectedRowKeys.value = []
}

</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}

.glass-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}

.button-table-option {
  padding: 0;
}
</style>